import type { ElementAnimationConfig } from '@/js/modules/animate/types';

import gsap from 'gsap';
import { parseElementConfig } from '@/js/modules/animate/parse-options';
import { mergePresets } from '@/js/modules/animate/presets';
import { DATA_PLAYED, DEFAULT_EASE } from '@/js/modules/animate/types';

const SHUTTER_ONLY_EASE = 'none';

function resolveEase(config: ElementAnimationConfig): string {
  if (config.ease)
    return config.ease;

  if (config.names.length === 1 && config.names[0] === 'shutter-down')
    return SHUTTER_ONLY_EASE;

  return DEFAULT_EASE;
}

export function setInitialState(element: HTMLElement, config: ElementAnimationConfig): void {
  const { from } = mergePresets(config.names);
  gsap.set(element, from);
}

export function revealElement(element: HTMLElement): void {
  gsap.set(element, { clearProps: 'opacity,transform,clipPath,overflow' });
  element.setAttribute(DATA_PLAYED, '');
}

export function playElementAnimation(
  element: HTMLElement,
  config: ElementAnimationConfig,
): gsap.core.Tween {
  const preset = mergePresets(config.names);

  return gsap.fromTo(element, preset.from, {
    ...preset.to,
    duration: config.duration,
    delay: config.delay,
    ease: resolveEase(config),
    onComplete: () => {
      element.setAttribute(DATA_PLAYED, '');
    },
  });
}

export function prepareElement(element: HTMLElement): ElementAnimationConfig | null {
  if (element.hasAttribute(DATA_PLAYED))
    return null;

  const config = parseElementConfig(element);
  if (!config)
    return null;

  setInitialState(element, config);
  return config;
}
